module.exports = __webpack_public_path__ + "img/Selection_012.a8385b84.png";